/**
 * Utils for 3dpscan.js
 */
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export { wait };
